import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

import { PageHeader } from '../../lib/page-header'

export type AdminPageHeaderProps = {
    className?: ClassName
    style?: React.CSSProperties
}

function AdminPageHeader({ className, style }: AdminPageHeaderProps): React.ReactElement {
    const MENU_LINKS = [
        { href: '/dashboard', labelCode: 'btnDashboard' },
        { href: '/chargepoints', labelCode: 'btnChargers' },
        { href: '/pools', labelCode: 'btnPools' },
        { href: '/users', labelCode: 'btnUsers' },
        { href: '/nfcTags', labelCode: 'btnRFID' },
        {
            href: '/loadbalancer',
            labelCode: 'btnLoadbalancer',
        },
        { href: '/measurementDevices', labelCode: 'btnMeasurementDevices' },
        { href: '/reports', labelCode: 'btnReports' },
        { href: '/settings', labelCode: 'btnSettings' },
    ]
    return <PageHeader className={cn(className)} style={style} links={MENU_LINKS} />
}

export default AdminPageHeader
